import Vue from 'vue'
import config from './custom-config.json'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue, config)
Vue.use(BootstrapVueIcons)
